module.exports = __webpack_public_path__ + "media/images/logos-cb9742580556706ebb9ddad37d2b6c2a.png";